(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chic-banner-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (root.dataset.chicInit) return;
      root.dataset.chicInit = '1';

      const track = root.querySelector('[data-chic-banners-track]');
      const slides = Array.from(root.querySelectorAll('[data-chic-banner]'));
      const videoOf = (slide) => slide?.querySelector('[data-chic-banner-video]');
      const soundBtn = root.querySelector('[data-chic-banners-sound]');
      const hasSound = (v) => v?.dataset.sound === 'true';
      let activeSlide = slides[0];
      let wantSound = true;

      const syncSoundBtn = () => {
        if (!soundBtn) return;
        const v = videoOf(activeSlide);
        soundBtn.hidden = !hasSound(v);
        const on = Boolean(v && !v.muted);
        soundBtn.setAttribute('aria-pressed', String(on));
        soundBtn.setAttribute('aria-label', on ? 'Mute video' : 'Turn sound on');
      };

      // Browsers block autoplay with sound until the visitor interacts, so fall back to muted
      const play = (slide) => {
        activeSlide = slide;
        const v = videoOf(slide);
        if (!v) { syncSoundBtn(); return; }
        v.currentTime = 0;
        v.muted = !(hasSound(v) && wantSound);
        const p = v.play();
        p?.catch(() => {
          v.muted = true;
          v.play()?.catch(() => {});
          syncSoundBtn();
        });
        syncSoundBtn();
      };
      const pause = (slide) => videoOf(slide)?.pause();

      soundBtn?.addEventListener('click', () => {
        const v = videoOf(activeSlide);
        if (!v) return;
        v.muted = !v.muted;
        wantSound = !v.muted;
        if (v.paused) v.play()?.catch(() => {});
        syncSoundBtn();
      });

      // A click or key press anywhere unlocks sound if autoplay forced it off
      const unlock = (e) => {
        if (soundBtn?.contains(e.target)) return;
        const v = videoOf(activeSlide);
        if (wantSound && hasSound(v) && v.muted) { v.muted = false; syncSoundBtn(); }
      };
      ['pointerdown', 'keydown'].forEach((t) => document.addEventListener(t, unlock, true));

      if (slides.length < 2) { play(slides[0]); return; }

      const dots = Array.from(root.querySelectorAll('[data-chic-banners-dot]'));
      const duration = Number(root.dataset.duration) || 5000;
      const autoplay = root.dataset.autoplay !== 'false';
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let current = 0;
      let timer;

      const show = (next) => {
        next = (next + slides.length) % slides.length;
        if (next === current) return;
        const from = slides[current];
        const to = slides[next];

        from.classList.remove('is-active');
        from.classList.add('is-leaving');
        from.setAttribute('aria-hidden', 'true');
        to.classList.add('is-active');
        to.removeAttribute('aria-hidden');
        slides.forEach((s) => s.querySelector('a')?.setAttribute('tabindex', s === to ? '0' : '-1'));
        setTimeout(() => { from.classList.remove('is-leaving'); pause(from); }, 900);
        play(to);

        dots.forEach((d, n) => {
          d.classList.toggle('is-active', n === next);
          if (n === next) d.setAttribute('aria-current', 'true');
          else d.removeAttribute('aria-current');
        });
        current = next;
      };

      // A video slide stays up until its clip ends; image slides use the timer
      const stop = () => clearTimeout(timer);
      const start = () => {
        stop();
        if (!autoplay || reduceMotion) return;
        const v = videoOf(slides[current]);
        if (v && !v.loop) return;
        timer = setTimeout(() => { show(current + 1); start(); }, duration);
      };

      slides.forEach((slide) => {
        videoOf(slide)?.addEventListener('ended', () => {
          if (slide !== slides[current] || !autoplay || reduceMotion) return;
          show(current + 1);
          start();
        });
      });

      root.querySelector('[data-chic-banners-prev]')?.addEventListener('click', () => { show(current - 1); start(); });
      root.querySelector('[data-chic-banners-next]')?.addEventListener('click', () => { show(current + 1); start(); });
      dots.forEach((dot) => dot.addEventListener('click', () => { show(Number(dot.dataset.chicBannersDot)); start(); }));

      // Swipe
      let x0 = null;
      let y0 = null;
      let swiped = false;
      track.addEventListener('pointerdown', (e) => { x0 = e.clientX; y0 = e.clientY; swiped = false; });
      track.addEventListener('pointerup', (e) => {
        if (x0 === null) return;
        const dx = e.clientX - x0;
        const dy = e.clientY - y0;
        x0 = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          swiped = true;
          show(current + (dx < 0 ? 1 : -1));
          start();
        }
      });
      track.addEventListener('click', (e) => {
        if (swiped) { e.preventDefault(); swiped = false; }
      }, true);

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);
      root.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { show(current - 1); start(); }
        if (e.key === 'ArrowRight') { show(current + 1); start(); }
      });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) { stop(); pause(slides[current]); }
        else { videoOf(slides[current])?.play()?.catch(() => {}); start(); }
      });

      play(slides[current]);
      start();
    };

    const boot = () => document.querySelectorAll('[data-chic-banners]').forEach(init);
    boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chic-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-chic-slider]').forEach((root) => {
    if (root.dataset.chicInit) return;
    root.dataset.chicInit = '1';

    const slides = Array.from(
      root.querySelectorAll('[data-chic-slide]')
    );

    if (slides.length < 2) {
      const video = root.querySelector('video');
      if (video) video.play().catch(() => {});
      return;
    }

    const dots = Array.from(
      root.querySelectorAll('[data-chic-dot]')
    );

    const duration = Number(root.dataset.slideDuration) || 4000;
    const reduceMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    let current = 0;
    let timer;

    const show = (index) => {
      current = (index + slides.length) % slides.length;

      slides.forEach((slide, n) => {
        const active = n === current;
        slide.classList.toggle('is-active', active);

        const video = slide.querySelector('video');

        if (video) {
          if (active) {
            video.currentTime = 0;
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        }
      });

      dots.forEach((dot, n) => {
        dot.classList.toggle('on', n === current);
      });
    };

    const start = () => {
      if (reduceMotion) return;
      clearInterval(timer);
      timer = setInterval(() => show(current + 1), duration);
    };

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        show(Number(dot.dataset.chicDot));
        start();
      });
    });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        clearInterval(timer);
      } else {
        start();
      }
    });

    show(0);
    start();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chic-key-ingredients"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (root.dataset.chicKiInit === '1') return;

      const track = root.querySelector('[data-chic-ki-track]');
      const prev = root.querySelector('[data-chic-ki-prev]');
      const next = root.querySelector('[data-chic-ki-next]');

      if (!track) return;
      root.dataset.chicKiInit = '1';

      const update = () => {
        const maxScroll = Math.max(
          0,
          track.scrollWidth - track.clientWidth
        );

        if (prev) {
          prev.disabled = track.scrollLeft <= 2;
        }

        if (next) {
          next.disabled = track.scrollLeft >= maxScroll - 2;
        }
      };

      const step = () => {
        const card = track.querySelector('.chic-ki__card');
        if (!card) return track.clientWidth * 0.8;

        const gap = parseFloat(
          getComputedStyle(track).columnGap
        ) || 0;

        return card.getBoundingClientRect().width + gap;
      };

      prev?.addEventListener('click', () => {
        track.scrollBy({ left: -step() });
      });

      next?.addEventListener('click', () => {
        track.scrollBy({ left: step() });
      });

      track.addEventListener('keydown', (event) => {
        if (event.target !== track) return;

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          track.scrollBy({ left: step() });
        } else if (event.key === 'ArrowLeft') {
          event.preventDefault();
          track.scrollBy({ left: -step() });
        }
      });

      track.addEventListener('scroll', update, {
        passive: true
      });

      track.querySelectorAll('img').forEach((image) => {
        if (!image.complete) {
          image.addEventListener('load', update, { once: true });
          image.addEventListener('error', update, { once: true });
        }
      });

      let observer;

      if ('ResizeObserver' in window) {
        observer = new ResizeObserver(update);
        observer.observe(track);
      } else {
        window.addEventListener('resize', update);
      }

      const cleanup = (event) => {
        if (!event.target.contains(root)) return;

        observer?.disconnect();
        window.removeEventListener('resize', update);
        document.removeEventListener(
          'shopify:section:unload',
          cleanup
        );
      };

      document.addEventListener(
        'shopify:section:unload',
        cleanup
      );

      requestAnimationFrame(update);
    };

    const boot = () => {
      document.querySelectorAll('[data-chic-ki]').forEach(init);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, {
        once: true
      });
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chic-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initChicProducts(root) {
      if (root.dataset.chicCollectionInit === '1') return;
      root.dataset.chicCollectionInit = '1';

      const toast = root.querySelector('[data-chic-toast]');
      let toastTimer;

      const showToast = (message) => {
        if (!toast) return;

        toast.textContent = message;
        toast.classList.add('show');

        clearTimeout(toastTimer);
        toastTimer = setTimeout(() => {
          toast.classList.remove('show');
        }, 2400);
      };

      // Same-page collection and type/tag tabs.
      const tabs = Array.from(
        root.querySelectorAll('[data-chic-panel-tab]')
      );

      const panels = root.querySelectorAll('[data-chic-panel]');

      const activateTab = (selectedTab) => {
        const selectedKey = selectedTab.dataset.chicPanelTab;

        tabs.forEach((tab) => {
          const active = tab === selectedTab;

          tab.classList.toggle('on', active);
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
        });

        panels.forEach((panel) => {
          panel.hidden = panel.dataset.chicPanel !== selectedKey;
        });
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => {
          activateTab(tab);
        });

        tab.addEventListener('keydown', (event) => {
          let nextIndex = index;

          if (event.key === 'ArrowRight') {
            nextIndex = (index + 1) % tabs.length;
          } else if (event.key === 'ArrowLeft') {
            nextIndex = (index - 1 + tabs.length) % tabs.length;
          } else if (event.key === 'Home') {
            nextIndex = 0;
          } else if (event.key === 'End') {
            nextIndex = tabs.length - 1;
          } else {
            return;
          }

          event.preventDefault();
          activateTab(tabs[nextIndex]);
          tabs[nextIndex].focus();
        });
      });

      // Wishlist, stored per browser.
      let wished = [];

      try {
        const stored = JSON.parse(
          localStorage.getItem('chic-wishlist') || '[]'
        );

        if (Array.isArray(stored)) {
          wished = stored.map(String);
        }
      } catch (error) {
        wished = [];
      }

      const wishButtons = root.querySelectorAll('[data-chic-wish]');

      const syncWishlist = () => {
        wishButtons.forEach((button) => {
          const active = wished.includes(button.dataset.chicWish);

          button.classList.toggle('on', active);
          button.setAttribute('aria-pressed', String(active));
        });
      };

      syncWishlist();

      wishButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();

          const id = button.dataset.chicWish;
          const index = wished.indexOf(id);

          if (index > -1) {
            wished.splice(index, 1);
          } else {
            wished.push(id);
          }

          syncWishlist();

          try {
            localStorage.setItem(
              'chic-wishlist',
              JSON.stringify(wished)
            );
          } catch (error) {
            // Storage may be unavailable in private browsing.
          }
        });
      });

      // Add to cart.
      root.querySelectorAll('[data-chic-add]').forEach((button) => {
        button.addEventListener('click', async (event) => {
          event.preventDefault();
          event.stopPropagation();

          if (button.disabled) return;
          button.disabled = true;

          const routesRoot = window.Shopify?.routes?.root || '/';

          try {
            const response = await fetch(
              routesRoot + 'cart/add.js',
              {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'Accept': 'application/json'
                },
                body: JSON.stringify({
                  id: Number(button.dataset.chicAdd),
                  quantity: 1
                })
              }
            );

            if (!response.ok) {
              throw new Error('Add to cart failed');
            }

            // The add succeeded even if refreshing cart UI fails.
            button.classList.add('done');
            showToast('Added to cart ✓');

            setTimeout(() => {
              button.classList.remove('done');
            }, 1600);

            try {
              const cartResponse = await fetch(
                routesRoot + 'cart.js',
                {
                  headers: { 'Accept': 'application/json' }
                }
              );

              if (cartResponse.ok) {
                const cart = await cartResponse.json();

                const cartEvent = new Event(
                  'shopify:cart:lines-update',
                  { bubbles: true }
                );

                cartEvent.promise = Promise.resolve({
                  cart: {
                    totalQuantity: cart.item_count
                  },
                  detail: {
                    itemCount: cart.item_count
                  }
                });

                document.dispatchEvent(cartEvent);
              }
            } catch (error) {
              // Product was added; cart UI refresh is optional.
            }
          } catch (error) {
            showToast('Could not add to cart');
          } finally {
            button.disabled = false;
          }
        });
      });
    }

    function initWithin(container) {
      if (container.matches?.('.chic-products')) {
        initChicProducts(container);
      }

      container.querySelectorAll('.chic-products').forEach(
        initChicProducts
      );
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        initWithin(document);
      }, { once: true });
    } else {
      initWithin(document);
    }

    // Reinitialize when the theme editor reloads the section.
    document.addEventListener('shopify:section:load', (event) => {
      initWithin(event.target);
    });

    // Show the corresponding tab when selected in the editor.
    document.addEventListener('shopify:block:select', (event) => {
      const blockId = event.detail?.blockId;
      if (!blockId) return;

      document.querySelectorAll('.chic-products').forEach((root) => {
        const tab = Array.from(
          root.querySelectorAll('[data-chic-panel-tab]')
        ).find((button) => {
          return button.dataset.chicPanelTab === blockId;
        });

        if (tab) tab.click();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chic-recommendations"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-chic-recs]').forEach((root) => {
    if (root.dataset.chicInit) return;
    root.dataset.chicInit = '1';

    const bind = () => {
      const toast = root.querySelector('[data-chic-toast]');
      let toastTimer;
      const showToast = (msg) => {
        if (!toast) return;
        toast.textContent = msg;
        toast.classList.add('show');
        clearTimeout(toastTimer);
        toastTimer = setTimeout(() => toast.classList.remove('show'), 2400);
      };

      let wished = [];
      try { wished = JSON.parse(localStorage.getItem('chic-wishlist') || '[]'); } catch (e) { wished = []; }
      root.querySelectorAll('[data-chic-wish]').forEach((btn) => {
        const id = btn.dataset.chicWish;
        if (wished.includes(id)) btn.classList.add('on');
        btn.addEventListener('click', (evt) => {
          evt.preventDefault();
          evt.stopPropagation();
          btn.classList.toggle('on');
          const i = wished.indexOf(id);
          if (i > -1) wished.splice(i, 1); else wished.push(id);
          try { localStorage.setItem('chic-wishlist', JSON.stringify(wished)); } catch (e) { /* noop */ }
        });
      });

      root.querySelectorAll('[data-chic-add]').forEach((btn) => {
        btn.addEventListener('click', async () => {
          btn.disabled = true;
          try {
            const res = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: Number(btn.dataset.chicAdd), quantity: 1 }),
            });
            if (!res.ok) throw new Error('add failed');
            const cart = await (await fetch((window.Shopify?.routes?.root || '/') + 'cart.js')).json();
            const evt = new Event('shopify:cart:lines-update', { bubbles: true });
            evt.promise = Promise.resolve({ cart: { totalQuantity: cart.item_count }, detail: { itemCount: cart.item_count } });
            document.dispatchEvent(evt);
            btn.classList.add('done');
            showToast('Added to cart ✓');
            setTimeout(() => btn.classList.remove('done'), 1600);
          } catch (e) {
            showToast('Could not add to cart');
          } finally {
            btn.disabled = false;
          }
        });
      });
    };

    const url = root.dataset.url;
    if (!url) { bind(); return; }

    fetch(url)
      .then((res) => res.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('.chic-recs__inner');
        if (fresh && fresh.children.length) {
          root.querySelector('.chic-recs__inner').replaceWith(fresh);
        }
        bind();
        if (document.documentElement.classList.contains('chic-anim')) {
          root.querySelectorAll('.chic-prod').forEach((el) => el.classList.add('chic-reveal', 'chic-in'));
        }
      })
      .catch(() => bind());
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chic-reels"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const instances = new Map();

    const init = (root) => {
      if (instances.has(root)) return;

      const videos = Array.from(
        root.querySelectorAll('.chic-reels__media video')
      );

      const reducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      );

      let observer = null;
      let disposed = false;

      const pauseVideo = (video) => {
        video.pause();
        video.closest('.chic-reels__card')?.classList.remove('is-playing');
      };

      const playVideo = (video) => {
        video.muted = true;

        const playResult = video.play();

        if (playResult && typeof playResult.then === 'function') {
          playResult
            .then(() => {
              if (disposed || reducedMotion.matches || document.hidden) {
                pauseVideo(video);
                return;
              }

              video.closest('.chic-reels__card')?.classList.add('is-playing');
            })
            .catch(() => {});
        }
      };

      const configureObserver = () => {
        observer?.disconnect();
        videos.forEach(pauseVideo);

        if (
          disposed ||
          reducedMotion.matches ||
          document.hidden ||
          !('IntersectionObserver' in window)
        ) {
          return;
        }

        const activeObserver = new IntersectionObserver(
          (entries) => {
            if (disposed || observer !== activeObserver) return;

            entries.forEach((entry) => {
              if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
                playVideo(entry.target);
              } else {
                pauseVideo(entry.target);
              }
            });
          },
          { threshold: [0, 0.5] }
        );

        observer = activeObserver;
        videos.forEach((video) => observer.observe(video));
      };

      const handleVisibility = () => configureObserver();
      const handleMotion = () => configureObserver();

      document.addEventListener('visibilitychange', handleVisibility);

      if (reducedMotion.addEventListener) {
        reducedMotion.addEventListener('change', handleMotion);
      }

      const cleanup = () => {
        disposed = true;
        observer?.disconnect();
        videos.forEach(pauseVideo);

        document.removeEventListener(
          'visibilitychange',
          handleVisibility
        );

        if (reducedMotion.removeEventListener) {
          reducedMotion.removeEventListener('change', handleMotion);
        }

        instances.delete(root);
      };

      instances.set(root, cleanup);
      configureObserver();
    };

    const boot = () => {
      document.querySelectorAll('[data-chic-reels]').forEach(init);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', boot);

    document.addEventListener('shopify:section:unload', (event) => {
      instances.forEach((cleanup, root) => {
        if (event.target === root || event.target.contains(root)) {
          cleanup();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
